import React from 'react';


function Odemefatura(){
    return(
        <div>
            Odeme-fatura page.
        </div>
    )

}

export default Odemefatura;